// extracted by css-extract-rspack-plugin
export default {"conversationCheckboxFilters":"conversationCheckboxFilters-X_3h5a","groupLabel":"groupLabel-j1zvC6"};